import { sanitizeFileUrl } from "./filePreview.js";

export function entityFilesScrollId(kind, id) {
  return `entity-files-${kind}-${id}`;
}

function pickSafeUrl(...candidates) {
  for (const candidate of candidates) {
    const safe = sanitizeFileUrl(candidate || "");
    if (safe) return safe;
  }
  return "";
}

export function buildServiceInlineFiles(serviceId) {
  const id = Number(serviceId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/service/${id}/dateien`,
    previewModule: "service_files",
    scrollTargetId: entityFilesScrollId("service", id),
    resolveFileUrl: (row) => {
      const fid = Number(row?.id);
      return pickSafeUrl(
        row?.secure_preview_url,
        row?.secure_download_url,
        row?.secure_url,
        Number.isFinite(fid) && fid > 0 ? `/api/service/dateien/${fid}/preview` : ""
      );
    },
  };
}

export function buildProjektInlineFiles(projektTyp, projektId) {
  const typ = String(projektTyp || "").trim().toLowerCase();
  const id = Number(projektId);
  if (!typ || !Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/projekte/${typ}/${id}/dateien`,
    previewModule: "project_files",
    projektTyp: typ,
    projektId: id,
    scrollTargetId: entityFilesScrollId("projekt", `${typ}-${id}`),
    resolveFileUrl: (row) => {
      const rowTyp = String(row?.typ_slug || row?.projekt_typ || typ).trim().toLowerCase();
      const fid = Number(row?.id);
      return pickSafeUrl(
        row?.secure_preview_url,
        row?.secure_download_url,
        row?.secure_url,
        rowTyp && Number.isFinite(fid) && fid > 0 ? `/api/projekte/${rowTyp}/dateien/${fid}/preview` : ""
      );
    },
  };
}

export function buildOfferteInlineFiles(offerteId) {
  const id = Number(offerteId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/offerten/${id}/dateien`,
    previewModule: "offer_files",
    entityId: id,
    scrollTargetId: entityFilesScrollId("offerte", id),
    resolveFileUrl: (row) =>
      pickSafeUrl(row?.secure_preview_url, row?.secure_download_url, row?.secure_url),
  };
}

export function buildWartungInlineFiles(vertragId) {
  const id = Number(vertragId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/wartungsvertraege/${id}/dateien`,
    previewModule: "maintenance_contract_files",
    entityId: id,
    scrollTargetId: entityFilesScrollId("wartung", id),
    resolveFileUrl: (row) =>
      pickSafeUrl(row?.secure_preview_url, row?.secure_download_url, row?.secure_url),
  };
}

export function buildObjektInlineFiles(objektId) {
  const id = Number(objektId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/objekte/${id}/uploads`,
    previewModule: "object_files",
    entityId: id,
    scrollTargetId: entityFilesScrollId("objekt", id),
    resolveFileUrl: (row) =>
      pickSafeUrl(row?.secure_preview_url, row?.secure_download_url, row?.secure_url),
  };
}

export function buildKundenInlineFiles(kundenId) {
  const id = Number(kundenId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    listUrl: `/kunden/${id}/uploads`,
    previewModule: "customer_files",
    entityId: id,
    scrollTargetId: entityFilesScrollId("kunde", id),
    resolveFileUrl: (row) =>
      pickSafeUrl(row?.secure_preview_url, row?.secure_download_url, row?.secure_url),
  };
}
